import styled from 'styled-components';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
import { getFont } from '@finect/tabular-utils/getFont';
export var OrganizationName = styled.a.withConfig({
  displayName: "Organization__OrganizationName",
  componentId: "sc-llqiif-0"
})(["margin-bottom:4px;color:currentColor;&:hover{color:", ";}", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.linkColor;
}, fontSmoothing);
export var OrganizationRole = styled.div.withConfig({
  displayName: "Organization__OrganizationRole",
  componentId: "sc-llqiif-1"
})(["font-weight:lighter;color:", ";", ";", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.fontLL;
}, getFont(-1, 'compact'), fontSmoothing);